import React, {useEffect} from "react";
import {
  AboutMe,
  Hero,
  Highlights,
  MyClients,
  MyServices,
  ScrollingCross,
  SEO,
  Skills,
  Testimonials,
  WorkGallery,
  WorkingProcess,
} from "../components";
import {testimonialsHomeData} from "../constants/Testimonials";
import {projectsHomeData} from "../constants/Projects";
import {useLocation} from "react-router-dom";

const Landing = ({scrollRef}) => {
  const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollTarget) {
      const id = location.state.scrollTarget;
      setTimeout(() => {
        scrollRef.current?.scrollToId(id);
      }, 300);
    }
  }, [location, scrollRef]);

  return (
    <main>
      <SEO
        title="Deep Kapadia | Senior Frontend Developer Specializing in React & Next.js"
        description="Welcome to the portfolio of Deep Kapadia – a Senior Frontend Developer with 9+ years of experience building high-performance websites using React, Next.js, HTML/CSS, and JavaScript. Specializing in Figma to HTML, UI/UX, and responsive design."
        keywords="Deep Kapadia, Frontend Developer, React Developer, Next.js Developer, Figma to HTML, Web Developer India, CSS Expert, UI UX Developer, Web Designer, Web Designer Surat, Surat, Portfolio Website"
        image="https://www.deepkapadia.work/images/preview.jpg"
        url="https://www.deepkapadia.work"
      />

      {/* Home */}
      <div id="home" style={{minHeight: "100vh"}}>
        <Hero />
      </div>

      <ScrollingCross
        topItems={[
          "Figma",
          "Framer",
          "Photoshop",
          "Illustrator",
          "Wireframing",
          "Prototyping",
          "Design Systems",
          "Component Libraries",
          "Interaction Design",
          "UX Consistency",
          "User-Centered Thinking",
          "Visual Hierarchy",
          "Pixel Perfection",
          "Brand-Driven UI",
          "Collaboration Ready",
          "Design → Code Bridge",
        ]}
        bottomItems={[
          "JavaScript",
          "TypeScript",
          "React",
          "Next.js",
          "GSAP",
          "Tailwind CSS",
          "Styled Components",
          "State Management",
          "Responsive UI",
          "Web Animation",
          "Framer Motion",
          "Clean Architecture",
          "Component Reusability",
          "Performance Optimization",
          "API Integration",
          "Code Scalability",
        ]}
      />

      {/* Services */}
      <div id="service" style={{minHeight: "100vh"}}>
        <MyServices />
      </div>

      <Highlights />

      {/* projects */}
      {/* <div id="projects" style={{minHeight: "100vh"}}> */}
      <WorkGallery isButtonHide={true} projects={projectsHomeData} />
      {/* </div> */}

      <Skills />

      {/* Testimonial */}
      <div id="testimonial" style={{minHeight: "100vh"}}>
        <Testimonials
          testimonialsList={testimonialsHomeData}
          isHeadingHide={true}
          isButtonHide={true}
        />
      </div>

      <WorkingProcess />

      {/* About */}
      <div id="about" style={{minHeight: "100vh"}}>
        <AboutMe />
      </div>

      <MyClients />
    </main>
  );
};

export default Landing;
